import { BrowserModule } from '@angular/platform-browser';
import {CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule, NO_ERRORS_SCHEMA, APP_INITIALIZER } from '@angular/core';
import {GlobalErrorHandler} from './core/global-error-handler';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgxSpinnerModule } from 'ngx-spinner';

import { OverlayContainer, Overlay } from '@angular/cdk/overlay';
import { MAT_MENU_SCROLL_STRATEGY } from '@angular/material/menu';
import { CustomOverlayContainer } from './theme/utils/custom-overlay-container';
import { menuScrollStrategy } from './theme/utils/scroll-strategy';

import { environment } from 'src/environments/environment';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader'; 
export function HttpLoaderFactory(httpClient: HttpClient) { 
  return new TranslateHttpLoader(httpClient, environment.url +'/assets/i18n/', '.json');
}


import { AppRoutingModule } from './app.routing';
import { AccountMenuComponent } from './components/account-menu/account-menu.component';
import { PrivacyControlsComponent } from './components/privacy-controls/privacy-controls.component';
import { PrivacyRequestsComponent } from './components/privacy-requests/privacy-requests.component';
import { AppComponent } from './app.component';

import { TopMenuComponent } from './theme/components/top-menu/top-menu.component';
import {MenuComponent, MyFilterPipe} from './theme/components/menu/menu.component';
import { SidenavMenuComponent } from './theme/components/sidenav-menu/sidenav-menu.component';
import { BreadcrumbComponent } from './theme/components/breadcrumb/breadcrumb.component';

import { AppSettings } from './app.settings';
import { AppService } from './app.service';
import { AppInterceptor } from './theme/utils/app-interceptor';
import { AuthSessionService, restoreSessionFactory } from './services/auth-session.service';
import { OptionsComponent } from './theme/components/options/options.component';
import { FooterComponent } from './theme/components/footer/footer.component';
import {ApiUrl} from "./shared/models/apiurl.models";
import {UsersService} from "./admin/users/users.service";
import {AdminService} from "./admin/admin.service";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {PriceViewService} from "./shared/price-view/price-view.service";
import {PagesComponentComponent} from "./pages/pages-component.component";
import {LoginComponent} from "./components/session/login/login.component";
import {TopNavbarComponent} from "./components/top-navbar/top-navbar.component";
import {HeaderComponent} from "./components/header/header.component";
import {LoginService} from "./components/session/login/login.service";
import {CartSidebarComponent} from "./components/cart-sidebar/cart-sidebar.component";
import {SectionPaddingComponent} from "./components/section-padding/section-padding.component";
import {LoadingFrameComponent} from "./components/loading-frame/loading-frame.component";
import {HomePageComponent} from "./pages/home-page/home-page.component";
import {TopCategoryComponent} from "./components/top-category/top-category.component";
import {CarouselSliderComponent} from "./components/carousel-slider/carousel-slider.component";
import {ProductItemsComponent} from "./components/product-items/product-items.component";
import {HeaderSearchComponent} from "./components/header-search/header-search.component";
import {PersonalAreaComponent} from "./components/personal-area/personal-area.component";
import {InfoComponent} from "./pages/personal/info/info.component";
import {PhoneVerifyComponent} from "./components/phone-verify/phone-verify.component";
import {MyAdsComponent} from "./pages/personal/my-ads/my-ads.component";
import {WishlistComponent} from "./pages/personal/wishlist/wishlist.component";
import {AdsComponent} from "./pages/personal/ads/ads.component";
import {AdsPageComponentDialog} from "./pages/personal/ads/ads-page/ads-page-component-dialog.component";
import {PersonalComponent} from "./pages/personal/personal.component";
import {DatePipe} from "@angular/common";
import {CarAdvFormComponent} from "./pages/create-adv/car-adv-form/car-adv-form.component";
import {AdalinePublishFormComponent} from "./pages/create-adv/adaline-publish-form/adaline-publish-form.component";
import {MainCategoryComponent} from "./pages/create-adv/main-category-component/main-category.component";
import {DynamicFormQuestionComponent} from "./pages/create-adv/dynamic-form-question/dynamic-form-question.component";
import {CreateAdvComponent} from "./pages/create-adv/create-adv.component";
import {AdvFormService} from "./pages/create-adv/services/adv-form.service";
import {FilterbaseService} from "./pages/shop/top-filter/filter-base/services/filterbase.service";
import {NadlanMapComponent} from "./components/nadlan-map/nadlan-map.component";
import {DynamicFormComponent} from "./pages/create-adv/dynamic-form/dynamic-form.component";
import {MatExpansionModule} from "@angular/material/expansion";
import {MatSelectModule} from "@angular/material/select";
import {MatButtonModule} from "@angular/material/button";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatSliderModule} from "@angular/material/slider";
import {NgbModule} from "@ng-bootstrap/ng-bootstrap";
import {MatIconModule} from "@angular/material/icon";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {TextWrapperComponent} from "./shared/text-wrapper/text-wrapper.component";
import {FilterPipe, UiSelectDropdownComponent} from "./components/ui-select-dropdown/ui-select-dropdown.component";
import {MultiSelectBoxComponent} from "./components/multi-select-box/multi-select-box.component";
import {ImageListComponent} from "./pages/create-adv/image-list/image-list.component";
import {PersonContactComponent} from "./components/person-contact/person-contact.component";
import {ImagesBoxComponent} from "./components/images-box/images-box.component";
import {PhoneValidationDialogComponent} from "./components/person-contact/phone-validation-dialog/phone-validation-dialog.component";
import {ImgCompressorDirective} from "./components/images-box/ img-compressor.directive";
import {OfferProductComponent} from "./components/offer-product/offer-product.component";
import {ProductItemsSliderComponent} from "./components/product-items-slider/product-items-slider.component";
import {SelectBigBoxComponent} from "./components/select-big-box/select-big-box.component";
import {SelectRouteComponent} from "./pages/create-adv/select-route/select-route.component";
import {CouponActivationComponent} from "./pages/personal/benefits/coupon-activation.component";
import {CreditCardComponent} from "./pages/create-adv/select-route/credit-card/credit-card.component";
import {FreeAdvComponent} from "./pages/create-adv/select-route/free-adv/free-adv.component";
import {SelectRemoteComponent} from "./components/forms/select-remote/select-remote.component";
import {DropdownComponent} from "./pages/create-adv/dropdown/dropdown.component";
import {ShopComponent} from "./pages/shop/shop.component";
import {ControlMessages} from "./shared/controlMessages/control-messages";
import {MainContentComponent} from "./pages/shop/main-content/main-content.component";
import {NavHeaderComponent} from "./pages/shop/nav-header/nav-header.component";
import {ProductsContainerComponent} from "./pages/shop/main-content/products-container/products-container.component";
import {AutoTabDirective, CarTypeComponent} from "./pages/create-adv/car-type/car-type.component";
import {CartProductItemComponent} from "./components/cart-sidebar/cart-product-item/cart-product-item.component";
import {CategoryItemComponent} from "./pages/shop/main-content/category-item/category-item.component";
import {ProductDetailsItemComponent} from "./pages/personal/wishlist/product-details-item/product-details-item.component";
import {PhoneMaskDirective} from "./shared/phoneMaskDirective/phone-mask.directive";
import {FieldMessageComponent} from "./shared/controlMessages/field-message/field-message.component";
import {
    FilterBasesFilter,
    SelectFieldComponent
} from "./pages/shop/top-filter/components/select-field/select-field.component";
import {TextBoxComponent} from "./pages/shop/top-filter/components/text-box/text-box.component";
import {CheckboxComponent} from "./pages/shop/top-filter/components/checkbox/checkbox.component";
import {TopFilterComponent} from "./pages/shop/top-filter/top-filter.component";
import {BestOffersComponent} from "./components/best-offers/best-offers.component";
import {FilterBaseComponent} from "./pages/shop/top-filter/filter-base/filter-base.component";
import {RangeTextComponent} from "./pages/shop/top-filter/components/range-text/range-text.component";
import {RangeSelectComponent} from "./pages/shop/top-filter/components/range-select/range-select.component";
import {AdvService} from "./core/advertisement/service/advertisement.service";
import {SharedModule} from "./shared/shared.module";
import {SearchFieldComponent} from "./pages/create-adv/dynamic-form/shared/search-field/search-field.component";
import {ImageCropperModule} from "ngx-image-cropper";
import {ProductsComponent} from "./pages/products/products.component";

import {GetValueItemProduct, LocalizedDescriptionPipe, SingleComponent} from "./pages/single/single.component";
import {AdvertisementComponent} from "./core/advertisement/advertisement.component";
import {SortByPipe} from "./pages/shop/top-filter/sort-by.pipe";
import {DateFieldComponent} from "./pages/shop/top-filter/components/date-field/date-field.component";
import {
    SelectCheckBoxsComponent
} from "./pages/shop/top-filter/components/select-check-boxs/select-check-boxs.component";
import {QuestionService} from "./pages/create-adv/services/question.service";
import {QuestionControlService} from "./pages/create-adv/services/question-control.service";

import {AdsService} from "./pages/personal/ads/services/ads.service";
import {
    CreditCardPaymentComponent
} from "./pages/create-adv/select-route/credit-card-payment/credit-card-payment.component";
import {TextFieldComponent} from "./components/text-field/text-field.component";
import {NotificationBellComponent} from "./components/notification-bell/notification-bell.component";
import {ChatRoomComponent} from "./components/chat-room/chat-room.component";
import {PublishButtonComponent} from "./components/publish-button/publish-button.component";
import {ActionBarButtonComponent} from "./components/page-actions/action-bar-button.component";
import {SearchPopupComponent} from "./components/header-search/search-popup/search-popup.component";
import {GoogleAuthButtonComponent} from "./components/google-auth-button/google-auth-button.component";
import {PhoneFormatterDirective} from "./directives/phone-format.directive";
import {StoryVideoUploaderComponent} from "./pages/create-adv/video-picker/story-video-uploader.component";
import {PhoneFormatDirective} from "./directives/phone-format";
import {FloatingNotificationContainerComponent} from "./shared/floating-notification/floating-notification-container.component";
import {ToastContainerComponent} from "./shared/toast/toast-container.component";
import {WorkersComponent} from "./components/worker/worker.component";
import {JobCirclesBannerComponent} from "./components/required/required.component";
import {PetListingsComponent} from "./components/pet/pet.component";
import {CarListingsComponent} from "./components/car-bar/car-bar.component";
import {NadlanListingsComponent} from "./components/nadlan-bar/nadlan-bar.component";
import {Sale2ListingsComponent} from "./components/sale2-bar/sale2-bar.component";
import {ProductComponent} from "./pages/product/product.component";
import {ReelsBarComponent} from "./components/reels-bar/reels-bar.component";
import {AboutComponent} from "./pages/about/about.component";
import {SellerProfileComponent} from "./pages/seller/seller-profile.component";
import {StoreComponent} from "./pages/personal/store/store.component";
import {BusinessStatusBannerComponent} from "./components/business-status-banner/business-status-banner.component";
import {PromoteAdDialogComponent} from "./components/promote-ad-dialog/promote-ad-dialog.component";
import {BusinessPerformanceComponent} from "./components/business-performance/business-performance.component";
import {FollowersComponent} from "./pages/personal/followers/followers.component";
import {FeedComponent} from "./pages/personal/feed/feed.component";
import {PrivacyComponent} from "./pages/privacy/privacy.component";
import {TermsComponent} from "./pages/terms/terms.component";
import {TrendsComponent} from "./pages/trends/trends.component";
import {TrendCommentThreadComponent} from "./pages/trends/trend-comment-thread.component";
import {VipDashboardComponent} from "./pages/personal/vip-dashboard/vip-dashboard.component";
import {PersonalShellComponent} from "./pages/personal/personal-shell/personal-shell.component";
import {VipSubscriptionComponent} from "./pages/personal/vip-subscription/vip-subscription.component";
import {ChatbotComponent} from "./components/chatbot/chatbot.component";
import {CartComponent} from "./pages/cart/cart.component";





@NgModule({
    imports: [
        BrowserModule,
        AccountMenuComponent,
        PrivacyControlsComponent,
        PrivacyRequestsComponent,
        BrowserAnimationsModule,
        HttpClientModule,
        FormsModule,
        ReactiveFormsModule,
        NgxSpinnerModule,
        MatSliderModule,
        NgbModule,
        ImageCropperModule,
        MatIconModule,
        MatExpansionModule,
        MatSelectModule,
        MatAutocompleteModule,
        MatButtonModule,
        MatFormFieldModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        }),
        SharedModule,
        AppRoutingModule,
        TextFieldComponent,
        NotificationBellComponent,
        ChatRoomComponent,
        PublishButtonComponent,
        ActionBarButtonComponent,
        SearchPopupComponent,
        GoogleAuthButtonComponent,
        PhoneFormatterDirective,
        StoryVideoUploaderComponent,
        PhoneFormatDirective,
        FloatingNotificationContainerComponent,
        WorkersComponent,
        JobCirclesBannerComponent,
        PetListingsComponent,
        CarListingsComponent,
        NadlanListingsComponent,
        Sale2ListingsComponent,
        ProductComponent,
        TrendCommentThreadComponent,
        ReelsBarComponent,
        CarouselSliderComponent,
        AdvertisementComponent,
        ChatbotComponent,
        CouponActivationComponent,
    ],
    declarations: [
        AppComponent,
        NadlanMapComponent,
        TopMenuComponent,
        MenuComponent,
        MyFilterPipe,
        SidenavMenuComponent,
        PagesComponentComponent,
        BreadcrumbComponent,
        OptionsComponent,
        FooterComponent,
        LoginComponent,
        TopNavbarComponent,
        HeaderComponent,
        CartSidebarComponent,
        SectionPaddingComponent,
        LoadingFrameComponent,
        HomePageComponent,
        TopCategoryComponent,
        ProductItemsComponent,
        HeaderSearchComponent,
        PersonalAreaComponent,
        InfoComponent,
        PhoneVerifyComponent,
        MyAdsComponent,
        WishlistComponent,
        AdsComponent,
        AdsPageComponentDialog,
        PersonalComponent,
        MainCategoryComponent,
        CarAdvFormComponent,
        AdalinePublishFormComponent,
        DynamicFormQuestionComponent,
        CreateAdvComponent,
        DynamicFormComponent,
        TextWrapperComponent,
        UiSelectDropdownComponent,
        MultiSelectBoxComponent,
        ImageListComponent,
        PersonContactComponent,
        ImagesBoxComponent,
        PhoneValidationDialogComponent,
        ImgCompressorDirective,
        AppComponent,
        HeaderComponent,
        FooterComponent,
        TopNavbarComponent,
        LoginComponent,
        TopCategoryComponent,
        ProductItemsComponent,

        ProductItemsSliderComponent,
        SectionPaddingComponent,
        CartSidebarComponent,
        HomePageComponent,
        CreateAdvComponent,
        CarAdvFormComponent,
        DynamicFormComponent,
        DynamicFormQuestionComponent,
        MainCategoryComponent,
        SelectBigBoxComponent,
        MultiSelectBoxComponent,
        PersonContactComponent,
        PhoneValidationDialogComponent,
        ImagesBoxComponent,
        PersonalComponent,
        AdsComponent,
        InfoComponent,
        AdsPageComponentDialog,
        SelectRouteComponent,
        ImageListComponent,
        CreditCardComponent,
        CreditCardPaymentComponent,
        FreeAdvComponent,
        SelectRemoteComponent,
        DropdownComponent,
        LoadingFrameComponent,
        ShopComponent,
        ControlMessages,
        AdsPageComponentDialog,
        MainContentComponent,
        NavHeaderComponent,
        ProductsContainerComponent,
        TopFilterComponent,
        BestOffersComponent,
        FilterBaseComponent,
        SelectFieldComponent,
        SelectCheckBoxsComponent,
        RangeTextComponent,
        RangeSelectComponent,
        CheckboxComponent,
        TextBoxComponent,
        FilterBasesFilter,
        PersonalAreaComponent,
        SearchFieldComponent,
        FieldMessageComponent,
        HeaderSearchComponent,
        UiSelectDropdownComponent,
        ImgCompressorDirective,
        AutoTabDirective,
        PhoneMaskDirective,
        WishlistComponent,
        ProductDetailsItemComponent,
        CategoryItemComponent,
        CartProductItemComponent,
        CarTypeComponent,
        FilterPipe,
        TextWrapperComponent,
        ProductsComponent,
        SingleComponent,
        GetValueItemProduct,
        LocalizedDescriptionPipe,
        SortByPipe,
        DateFieldComponent,
        AboutComponent,
        SellerProfileComponent,
        StoreComponent,
        BusinessStatusBannerComponent,
        PromoteAdDialogComponent,
        BusinessPerformanceComponent,
        FollowersComponent,
        FeedComponent,
        PrivacyComponent,
        TermsComponent,
        TrendsComponent,
        VipDashboardComponent,
        PersonalShellComponent,
        VipSubscriptionComponent,
        CartComponent,
        ToastContainerComponent,
    ],
    providers: [
        AppSettings,
        AppService,
        AdminService,
        ApiUrl,
        UsersService,
        AdsService,
        AdvFormService,
        FilterbaseService,
        LoginService,
        DatePipe,
        PriceViewService,
        SharedModule,
        QuestionService,
        QuestionControlService,
        {provide: OverlayContainer, useClass: CustomOverlayContainer},
        {provide: MAT_MENU_SCROLL_STRATEGY, useFactory: menuScrollStrategy, deps: [Overlay]},
        {provide: HTTP_INTERCEPTORS, useClass: AppInterceptor, multi: true},
        // POD1-8: the access token is memory-only, so it is gone after a
        // page reload. This performs one silent refresh at bootstrap using
        // the HttpOnly cookie, before the app renders.
        {
            provide: APP_INITIALIZER,
            useFactory: restoreSessionFactory,
            deps: [AuthSessionService],
            multi: true
        },
        {provide: ErrorHandler, useClass: GlobalErrorHandler}
    ],
    bootstrap: [AppComponent],
    exports: [
        FilterPipe,
        MyFilterPipe,
        SelectRemoteComponent,

    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class AppModule { }
